import { Colors } from '@prezi/dragon';
export var DesignTheme = {
  buttonColor: Colors.teal400,
  buttonColorHover: Colors.teal300,
  buttonBorderColor: Colors.teal300,
  buttonTextColor: Colors.white,
  iconFilterColor: 'invert(71%) sepia(32%) saturate(6156%) hue-rotate(136deg) brightness(94%) contrast(100%);',
  CTABorderRadius: '3px'
};